export const APP_NAME = 'RegistrationProfiles';
export const DEFAULT_PAGE_SIZE = 10;
export const DATE_FORMAT = 'MMM dd, yyyy';
